// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"9cac71e3","517":"33ebfc2e"}[chunkId] + ".chunk.js";
};